// tslint:disable: completed-docs
import {
    SET_ADDITIONAL_CONTENT_DOWNLOADED,
    SET_CURRENT_OFFERS,
    SET_CURRENT_OFFERS_FAILED,
    SET_CURRENT_OFFERS_SUCCESS,
    SET_DEFAULT_STATE,
} from './constant';

export const setDefaultState = () => {
    return {
        type: SET_DEFAULT_STATE,
    };
};

/**
 * displays offer after the user has set what he has and what he wants
 * or the default offer if nothing or no valid offer is selected
 */
export const setCurrentOffers = () => {
    return {
        type: SET_CURRENT_OFFERS,
    };
};
export const setCurrentOfferSuccess = (offers, isDefault) => {
    return {
        type: SET_CURRENT_OFFERS_SUCCESS,
        offers,
        isDefault,
    };
};
export const setCurrentOfferFailed = () => {
    return {
        type: SET_CURRENT_OFFERS_FAILED,
    };
};

export const setAdditionalContentDownloaded = () => {
    return {
        type: SET_ADDITIONAL_CONTENT_DOWNLOADED,
    };
};
